<script>
import TablePage from '@/found/components/table_page';
import Form from '../form/form.vue';

export default {
  extends: TablePage,
  components: {
    // Modal,
    Form,
  },
  data() {
    return {
      formConfig: {},
      modalConfig: {
        title: '新增',
        visible: false,
        type: 'Modal',
      },
    };
  },
  mounted() {
    this.getConfigList('channel-cost-list');
  },
  methods: {
    setColumn(v) {
      const rows = v;
      if (rows.field === 'productCode') {
        rows.isSearch = true;
        rows.apiUrl = '/mdm/mdmPositionLevelController/selectList';
        rows.optionsKey = {
          label: 'positionLevelName',
          value: 'positionLevelCode',
        };
      }
      return rows;
    },
    modalClick({ val, row }) {
      if (val.code === 'add') {
        this.modalConfig.title = '新增';
        this.openModal();
      } else if (val.code === 'edit') {
        this.modalConfig.title = '编辑';
        this.formConfig.id = row.id;
        this.formConfig.edit = true;
        this.openModal();
      }
    },
  },
};
</script>
